import React from 'react'
import MigrationResourcePage from 'domains/dashboard-migration/resource-page'
// src/routes/finance-team/finance-team-routes.js

import finance_team_refund_routes from 'routes/finance-team/refund'

import FinanceUploadCostCsvPage from 'domains/inventory/pages/inventory-cost-csv-import-page'

// === Payments ===
import { FinancePaymentsListPage } from
  'domains/finance/payments/pages/list-page'
import { FinancePaymentsDetailPage } from
  'domains/finance/payments/pages/detail-page'
import FinanceDealsListPage from 'domains/finance/deals/pages/finance-deals-list-page'
import Phase3ProductQueuePage from 'domains/phase3-inbound-journey/pages/Phase3ProductQueuePage'
import { PHASE3_PRODUCT_SCOPES } from 'domains/phase3-inbound-journey/constants'
// CONSIGNOR_SETTLEMENT_EARLY_WEEK3_FINANCE_IMPORT_START
import {
  ConsignorSettlementDetailPage,
  ConsignorSettlementsListPage
} from 'domains/consignor-settlements/pages'
// CONSIGNOR_SETTLEMENT_EARLY_WEEK3_FINANCE_IMPORT_END
// import FinanceDealsDetailPage from 'domains/finance/deals/pages'

// === Revenue: Consignor ===
import { ConsignorSentListPage } from
  'domains/revenue/consignor/pages/sent-list-page'
import ConsignorCuratorQueuePage from
  'domains/revenue/consignor/pages/curator-queue-page'
import ConsignorFinanceQueuePage from
  'domains/revenue/consignor/pages/finance-queue-page'

// === Revenue: Seller (BKO) ===
import { SellerBuyingQueuePage } from
  'domains/revenue/seller/pages/buying-queue-page'
import { SellerFinanceQueuePage } from
  'domains/revenue/seller/pages/finance-queue-page'

// === Shared / hidden ===
import RevenueHJListPage from
  'domains/revenue/pages/hj-list-page'
import { RevenueDetailPage } from
  'domains/revenue/pages/detail-page'
import { RevenueTransferPage } from
  'domains/revenue/pages/transfer-page'


const FINANCE_SETTLEMENT_ROLES = [ 'owner', 'admin', 'finance' ]
const FINANCE_SETTLEMENT_SUPERUSER_ROLES = [ 'owner', 'admin' ]
const FINANCE_APPROVAL_H_EMAILS = [ 'galuh@belleandkate.com', 'galuh.belleandkate@gmail.com', 'putri@belleandkate.com', 'putri.belleandkate@gmail.com' ]
const FINANCE_APPROVAL_C_EMAILS = [ 'ikhfa@belleandkate.com', 'ikhfa.belleandkate@gmail.com', 'putri@belleandkate.com', 'putri.belleandkate@gmail.com' ]
const FINANCE_APPROVAL_W_EMAILS = [ 'aulia@belleandkate.com', 'aulianuraini.belleandkate@gmail.com', 'putri@belleandkate.com', 'putri.belleandkate@gmail.com' ]
const FINANCE_TRANSFER_EMAILS = [
  'deriska@belleandkate.com',
  'watik@belleandkate.com',
  'riska.belleandkate@gmail.com',
  'watik.belleandkate@gmail.com',
  'putri@belleandkate.com',
  'putri.belleandkate@gmail.com'
]
const FINANCE_SETTLEMENT_EMAILS = [
  ...FINANCE_APPROVAL_H_EMAILS,
  ...FINANCE_APPROVAL_W_EMAILS,
  ...FINANCE_APPROVAL_C_EMAILS,
  ...FINANCE_TRANSFER_EMAILS
]


const finance_team_routes = {
  collapse  : true,
  path      : '/finance',
  name      : 'Finance Team',
  icon      : 'fas fa-money-bill-wave text-green',
  state_key : 'finance_team_collapse',
  views     : [
    {
      path: '/finance/invoice-archive',
      name: 'Invoice Archive',
      miniName: 'IA',
      allowedRoles: [ 'owner', 'purchasing', 'finance' ],
      component: (props) => <MigrationResourcePage { ...props } resourceKey='invoices' archive />,
      layout: '/app'
    },
    // ===== Payments =====
    {
      path      : '/finance/payments/list',
      name      : 'Payment List',
      miniName  : 'P',
      component : FinancePaymentsListPage,
      layout    : '/app'
    },
    {
      path      : '/finance/payments/:id',
      name      : 'Payment Detail',
      component : FinancePaymentsDetailPage,
      layout    : '/app',
      invisible : true
    },
    {
      path      : '/finance/deals',
      name      : 'Deals List',
      miniName  : 'L',
      component : FinanceDealsListPage,
      layout    : '/app',
    },

    {
      path      : '/finance/inbound-journey/bka-appraisal',
      name      : 'BKA Appraisal Edit',
      miniName  : 'BA',
      component : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.APPRAISAL_NEEDED } title='BKA Appraisal Edit' apiNamespace='finance' />,
      layout    : '/app',
      invisible : true
    },
    {
      path      : '/finance/upload-cost-csv',
      name      : 'Upload Cost CSV',
      miniName  : 'UC',
      component : FinanceUploadCostCsvPage,
      layout    : '/app'
    },
    // {
    //   path      : '/sales/deals/:id',
    //   name      : 'Deal Detail',
    //   miniName  : 'D',
    //   component : FinanceDealsDetailPage,
    //   layout    : '/app',
    //   invisible : true
    // },

    // CONSIGNOR_SETTLEMENT_EARLY_WEEK3_FINANCE_ROUTES_START
    {
      collapse  : true,
      name      : 'Transfer Request',
      miniName  : 'TR',
      state_key : 'finance_team_transfer_request_collapse',
      views     : [
        {
          path          : '/finance/transfer-request/approval-hermes',
          name          : 'Approval - Hermes',
          miniName      : 'H',
          component     : (props) => (
            <ConsignorSettlementsListPage
              { ...props }
              canNegotiate={ false }
              canSync={ false }
              financeApproval={ true }
              fixedInternalCategory='H'
              settlementKind='all'
              detailBasePath='/app/finance/transfer-request'
              pageSubTitle='Approval - Hermes'
              teamLabel='Finance'
            />
          ),
          layout        : '/app',
          allowedRoles  : FINANCE_SETTLEMENT_SUPERUSER_ROLES,
          allowedEmails : FINANCE_APPROVAL_H_EMAILS
        },
        {
          path          : '/finance/transfer-request/approval-watch',
          name          : 'Approval - Watch',
          miniName      : 'W',
          component     : (props) => (
            <ConsignorSettlementsListPage
              { ...props }
              canNegotiate={ false }
              canSync={ false }
              financeApproval={ true }
              fixedInternalCategory='W'
              settlementKind='all'
              detailBasePath='/app/finance/transfer-request'
              pageSubTitle='Approval - Watch'
              teamLabel='Finance'
            />
          ),
          layout        : '/app',
          allowedRoles  : FINANCE_SETTLEMENT_SUPERUSER_ROLES,
          allowedEmails : FINANCE_APPROVAL_W_EMAILS
        },
        {
          path          : '/finance/transfer-request/approval-curated',
          name          : 'Approval - Curated',
          miniName      : 'C',
          component     : (props) => (
            <ConsignorSettlementsListPage
              { ...props }
              canNegotiate={ false }
              canSync={ false }
              financeApproval={ true }
              fixedInternalCategory='C'
              settlementKind='all'
              detailBasePath='/app/finance/transfer-request'
              pageSubTitle='Approval - Curated'
              teamLabel='Finance'
            />
          ),
          layout        : '/app',
          allowedRoles  : FINANCE_SETTLEMENT_SUPERUSER_ROLES,
          allowedEmails : FINANCE_APPROVAL_C_EMAILS
        }
      ]
    },
    {
      path          : '/finance/transfer-request/process',
      name          : 'Ready to Transfer',
      miniName      : '',
      component     : (props) => (
        <ConsignorSettlementsListPage
          { ...props }
          canNegotiate={ false }
          canSync={ false }
          financeProcess={ true }
          settlementKind='all'
          detailBasePath='/app/finance/transfer-request'
          pageSubTitle='Ready to Transfer'
          teamLabel='Finance'
        />
      ),
      layout        : '/app',
      allowedRoles  : FINANCE_SETTLEMENT_SUPERUSER_ROLES,
      allowedEmails : FINANCE_TRANSFER_EMAILS
    },
    {
      path         : '/finance/transfer-request/transfer/:id',
      name         : 'Transfer Detail',
      miniName     : 'TD',
      component    : (props) => (
        <ConsignorSettlementDetailPage
          { ...props }
          canNegotiate={ false }
          canFinanceTransfer={ true }
          transferDetail={ true }
          settlementKind='all'
          listPath='/app/finance/transfer-request/process'
          teamLabel='Finance'
        />
      ),
      layout       : '/app',
      allowedRoles  : FINANCE_SETTLEMENT_ROLES,
      allowedEmails : FINANCE_SETTLEMENT_EMAILS,
      invisible     : true
    },
    {
      path         : '/finance/transfer-request/:id',
      name         : 'Transfer Request Detail',
      miniName     : 'TD',
      component    : (props) => (
        <ConsignorSettlementDetailPage
          { ...props }
          canNegotiate={ false }
          canFinanceTransfer={ true }
          settlementKind='all'
          listPath='/app/finance/transfer-request/process'
          teamLabel='Finance'
        />
      ),
      layout       : '/app',
      allowedRoles  : FINANCE_SETTLEMENT_ROLES,
      allowedEmails : FINANCE_SETTLEMENT_EMAILS,
      invisible     : true
    },
    // CONSIGNOR_SETTLEMENT_EARLY_WEEK3_FINANCE_ROUTES_END

    // ===== Consignor =====
    // {
    //   collapse  : true,
    //   name      : 'Consignor',
    //   miniName  : 'C',
    //   state_key : 'finance_consignor_collapse',
    //   views     : [
    //     {
    //       path      : '/finance/consignor/hj-only',
    //       name      : 'List (HJ Only)',
    //       miniName  : 'HJ',
    //       component : RevenueHJListPage,
    //       layout    : '/app',
    //       invisible : true
    //     },
    //     {
    //       path      : '/finance/consignor/sales-confirmation',
    //       name      : 'Sales Confirmation',
    //       miniName  : 'SA',
    //       component : ConsignorSentListPage,
    //       layout    : '/app',
    //       invisible : true
    //     },
    //     {
    //       path      : '/finance/consignor/product-curator',
    //       name      : 'Product Curator',
    //       miniName  : 'PC',
    //       component : ConsignorCuratorQueuePage,
    //       layout    : '/app',
    //       invisible : true
    //     },
    //     {
    //       path      : '/finance/consignor/transfer',
    //       name      : 'Transfer Consignor',
    //       miniName  : 'TR',
    //       component : ConsignorFinanceQueuePage,
    //       layout    : '/app'
    //     }
    //   ]
    // },

    // ===== Seller (BKO) =====
    // {
    //   collapse  : true,
    //   name      : 'Seller (BKO)',
    //   miniName  : 'S',
    //   state_key : 'finance_seller_collapse',
    //   views     : [
    //     {
    //       path      : '/finance/seller/hj-only',
    //       name      : 'List (HJ Only)',
    //       miniName  : 'HJ',
    //       component : RevenueHJListPage,
    //       layout    : '/app',
    //       invisible : true
    //     },
    //     {
    //       path      : '/finance/seller/buying-team',
    //       name      : 'Buying Team',
    //       miniName  : 'BT',
    //       component : SellerBuyingQueuePage,
    //       layout    : '/app',
    //       invisible : true
    //     },
    //     {
    //       path      : '/finance/seller/transfer',
    //       name      : 'Transfer Seller',
    //       miniName  : 'TR',
    //       component : SellerFinanceQueuePage,
    //       layout    : '/app'
    //     }
    //   ]
    // },

    // ===== Refund =====
    {
      collapse  : true,
      name      : 'Refund',
      miniName  : 'Ref',
      state_key : 'refund_collapse',
      views     : finance_team_refund_routes,
      invisible : true
    },

    // ===== Hidden pages =====
    {
      path      : '/finance/revenues/:id',
      name      : 'Revenue Detail',
      component : RevenueDetailPage,
      layout    : '/app',
      invisible : true
    },
    {
      path      : '/finance/revenues/:id/transfer',
      name      : 'Revenue Transfer',
      component : RevenueTransferPage,
      layout    : '/app',
      invisible : true
    }
  ]
}

export default finance_team_routes
